import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/partial/AdminNavbar";
import Button from "../../components/common/Button";
import FileUploader from "../../components/common/FileUploader";
import Modal from "react-modal";
import {
  addCarousel,
  deleteCarouselData,
  getCarouselData,
} from "../../store/dashboard/reducer";
import {
  updateNoticeData,
  getOneNoticeData,
} from "../../store/notices/reducer";
import { useDispatch, useSelector } from "react-redux";
import { IoMdAdd } from "react-icons/io";

Modal.setAppElement("#root");

const Dashboard = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedCarouselId, setSelectedCarouselId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [noticeID, setNoticeID] = useState("");
  const [updatedTitle, setUpdatedTitle] = useState("");
  const [updatedDetails, setUpdatedDetails] = useState("");
  const [isPopupChecked, setIsPopupChecked] = useState(false);

  const dispatch = useDispatch();

  const carouselData = useSelector(
    (state) => state.carouselReducer.carouselData,
  );

  console.log("Carousel Data:", carouselData); // Debugging log
  const OneNoticeData = useSelector(
    (state) => state.noticeReducer.OneNoticeData,
  );
  const noticeData = useSelector((state) => state.noticeReducer.noticeData);

  const handleImageClick = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const inactivePopups = noticeData.filter((notice) => {
      return (
        notice.popup &&
        new Date(notice.popupExpiryDate).getTime() < new Date().getTime()
      );
    });

    const ids = inactivePopups.map((notice) => notice._id);
    setNoticeID(ids);
  }, [noticeData]);

  useEffect(() => {
    if (noticeID.length) {
      noticeID.forEach((id) => {
        dispatch(getOneNoticeData(id));
      });
    }
  }, [dispatch, noticeID]);

  useEffect(() => {
    if (OneNoticeData) {
      setUpdatedTitle(OneNoticeData.title || "");
      setUpdatedDetails(OneNoticeData.details || "");
      setIsPopupChecked(false);
    }
  }, [OneNoticeData]);

  useEffect(() => {
    if (noticeID) {
      noticeID.forEach((id) => {
        const updatedNoticeData = {
          title: updatedTitle,
          details: updatedDetails,
          popup: isPopupChecked,
          days: 0,
        };
        dispatch(updateNoticeData(id, updatedNoticeData));
      });
    }
  }, [updatedTitle, updatedDetails, isPopupChecked, noticeID, dispatch]);

  const openAddModal = () => setModalOpen(true);
  const closeAddModal = () => {
    setModalOpen(false);
    setUploadedFiles([]);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage("");
  };

  const handleFilesUploaded = (files) => {
    setUploadedFiles([...files]);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    uploadedFiles.forEach((file) => {
      formData.append("photos", file);
    });

    dispatch(addCarousel(formData)).then(() => {
      closeAddModal();
      dispatch(getCarouselData());
    });
  };

  const handleDelete = (id, photo) => {
    if (window.confirm("Are you sure you want to delete this photo?")) {
      dispatch(deleteCarouselData(id, photo)).then(() => {
        dispatch(getCarouselData());
      });
    }
  };

  useEffect(() => {
    dispatch(getCarouselData());
  }, [dispatch]);

  useEffect(() => {
    if (carouselData?.data?.length > 0 && !selectedCarouselId) {
      setSelectedCarouselId(carouselData.data[0]._id);
    }
  }, [carouselData, selectedCarouselId]);

  return (
    <div className="flex flex-col md:flex-row bg-white min-h-screen">
      <div className="lg:w-1/5 bg-white">
        <AdminNavbar />
      </div>
      <div className="flex-1 p-6">
        <div className="text-center border-b-4 border-black pb-4">
          <h2 className="text-3xl font-bold text-gray-800">Carousel</h2>
          <Button
            type="primary"
            className="mt-4  flex justify-center items-center px-4 py-2"
            onClick={openAddModal}
          >
            <IoMdAdd className="mr-1 text-xl" />
            Add New Carousel
          </Button>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {((carouselData && carouselData.data) || []).map((carousel) =>
            (carousel.photos || []).map((photo, index) => (
              <div
                key={index}
                onClick={() => handleImageClick(photo)}
                className="relative bg-white rounded-lg shadow-md overflow-hidden group cursor-pointer"
              >
                {!isModalOpen && (
                  <div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>
                )}
                <img
                  src={photo}
                  alt="Carousel"
                  className="w-full h-64 object-cover transition-transform group-hover:scale-105 z-0"
                />
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(carousel._id, photo);
                  }}
                  style={{ zIndex: isModalOpen ? -1 : 10 }}
                  className="absolute top-2 right-2 text-white text-xl font-bold p-1 bg-red-500 rounded-full hover:scale-110 transition"
                >
                  ✕
                </button>
              </div>
            )),
          )}
        </div>
      </div>

      {/* Add Carousel Modal */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={closeAddModal}
        ariaHideApp={false}
        className="fixed inset-0 flex items-center justify-center p-4 z-20"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-20"
      >
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full relative">
          <button
            onClick={closeAddModal}
            className="absolute top-3 right-3 text-gray-500 hover:text-red-600 text-2xl"
          >
            &times;
          </button>
          <h3 className="text-xl font-bold mb-4">Add New Carousel</h3>
          <FileUploader
            onFilesUploaded={handleFilesUploaded}
            allowMultiple={true}
          />
          <div className="mt-6 flex justify-end space-x-4">
            <Button
              type="primary"
              className=" px-6 py-2"
              onClick={handleSubmit}
            >
              Submit
            </Button>
            <Button
              type="secondary"
              className=" px-6 py-2 rounded shadow transition"
              onClick={closeAddModal}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      {/* Full Image Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="fixed inset-0 flex items-center justify-center z-50 p-4"
        overlayClassName="fixed inset-0 bg-black bg-opacity-70 transition-opacity duration-300"
        ariaHideApp={false}
      >
        <div className="relative bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-auto p-4">
          <button
            onClick={closeModal}
            className="absolute top-2 right-2 text-gray-800 bg-white opacity-75 hover:scale-125 text-2xl rounded-full px-2 py-0.5"
          >
            ✕
          </button>
          <img
            src={currentImage}
            alt="Full View"
            className="w-full h-auto object-contain rounded"
          />
        </div>
      </Modal>
    </div>
  );
};

export default Dashboard;
